import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCommunitiesAndCategorys, getMyCommunities } from '../../actions/userActions';
import ZonesView from '../../containers/Zones/Zones';



const Zones = () => {
  const {communitysAndCategorys,listOfMyCommunities} = useSelector(state=>state.userInfo)
  const [text, setText] = useState("")
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch( getCommunitiesAndCategorys(text))

  return () => {
    
  };
}, [text]);
useEffect(() => {
  dispatch( getMyCommunities())

return () => {
  
};
}, []);
  return <ZonesView zones={communitysAndCategorys} myZones={listOfMyCommunities} searchAction ={setText}/>
};

export default Zones;
